<template>
  <div class="taber">
    <div
      class="taber_c"
      @click="tap(index)"
      v-for="(item, index) in taber"
      :key="index"
    >
      <div class="taber_c_icon" v-if="now_route_path != item.route_path">
        <img :src="item.icon" alt="" />
      </div>
      <div class="taber_c_icon" v-else><img :src="item.sel_icon" alt="" /></div>
      <div class="taber_c_p">{{ item.p }}</div>
    </div>

    <!--   <div class="taber_c" @click="changeindextap()">
      <div class="taber_c_icon"><img :src="isShowindex ? '/static/newprojecticon/yixuanindex.png' : '/static/newprojecticon/index.png'"/></div>
      <div class="taber_c_p">服务首页</div>
    </div>
    <div class="youlegoutabiconbox" @click="changegoutap()">
      <img class="youlegoutabicon" src="/static/youlegoutab.png" />
    </div>
    <div class="taber_c" @click="changeminetap()">
      <div class="taber_c_icon"><img :src="isShowmine ? '/static/newprojecticon/yixuanmine.png' : '/static/newprojecticon/mine.png'"  /></div>
      <div class="taber_c_p">个人中心</div>
    </div> -->
  </div>
</template>
<script>
import httper from "../../api/http.js";
export default {
  data() {
    return {
      taber: [
        {
          icon: "/static/weixuanindex.png",
          sel_icon: "/static/yixuanindex.png",
          p: "服务首页",
          route_path: "/"
        },

        {
          icon: "/static/weixuanyoulegou.png",
          sel_icon: "/static/yixuanyoulegou.png",
          p: "来享GO",
          route_path: "/youlegou"
        },
        {
          icon: "/static/weixuanmine.png",
          sel_icon: "/static/yixuanmine.png",
          p: "个人中心",
          route_path: "/mine"
        }
      ],
      now_route_path: "", //当前路由路径
      isShowmine: false,
      isShowindex: true,
      index: 0,
      availableUser: false,
      userinfo: {}
    };
  },
  created() {
    this.now_route_path = this.$route.path;
    // this.request("getUserInfo")
  },
  mounted() {},
  methods: {
    changeindextap() {
      this.isShowindex = true;
      this.isShowmine = false;
      this.$router.push({
        path: "/"
      });
    },
    changegoutap() {
      this.isShowindex = false;
      this.isShowmine = false;
      this.$router.push({
        path: "/youlegou"
      });
    },
    changeminetap() {
      this.isShowindex = false;
      this.isShowmine = true;
      this.$router.push({
        path: "/mine"
      });
    },
    tap(e) {
      let that = this;
      switch (e) {
        case 0:
          this.$router.push({
            path: "/"
          });
          break;
        case 1:
          this.$router.push({
            path: "/youlegou"
          });
          break;
        case 2:
          this.$router.push({
            path: "/mine"
          });
          break;
      }
      // console.log("e", e);
      // if (this.availableUser) {
      //   switch (e) {
      //     case 0:
      //       this.$router.push({
      //         path: "/"
      //       });
      //       break;
      //     case 1:
      //       this.$router.push({
      //         path: "/youlegou"
      //       });
      //       break;
      //     case 2:
      //       this.$router.push({
      //         path: "/mine"
      //       });
      //       break;
      //   }
      // } else {
      //   switch (e) {
      //     case 0:
      //       this.$router.push({
      //         path: "/"
      //       });
      //       break;
      //     case 1:
      //       this.$router.push({
      //         path: "/mine"
      //       });
      //       break;
      //   }
      // }
    },
    //调接口封装
    request(type, requestData = {}) {
      let that = this;
      switch (type) {
        //获取用户信息
        case "getUserInfo":
          httper.get(
            "wechat/user/info",
            requestData,
            res => {
              if (res.code === 0) {
                this.userinfo = res.data;
                var userId = [25];
                for (var i = 0; i < userId.length; i++) {
                  if (userId[i] == that.userinfo.id) {
                    this.availableUser = true;
                  } else {
                    this.availableUser = false;
                  }
                }
                if (this.availableUser) {
                  this.taber = [
                    {
                      icon: "/static/newprojecticon/index.png",
                      sel_icon: "/static/newprojecticon/yixuanindex.png",
                      p: "服务首页",
                      route_path: "/"
                    },
                    {
                      icon: "/static/weixuanyoulegou.png",
                      sel_icon: "/static/yixuanyoulegou.png",
                      p: "来享GO",
                      route_path: "/youlegou"
                    },
                    {
                      icon: "/static/newprojecticon/mine.png",
                      sel_icon: "/static/newprojecticon/yixuanmine.png",
                      p: "个人中心",
                      route_path: "/mine"
                    }
                  ];
                } else {
                  this.taber = [
                    {
                      icon: "/static/newprojecticon/index.png",
                      sel_icon: "/static/newprojecticon/yixuanindex.png",
                      p: "服务首页",
                      route_path: "/"
                    },
                    {
                      icon: "/static/newprojecticon/mine.png",
                      sel_icon: "/static/newprojecticon/yixuanmine.png",
                      p: "个人中心",
                      route_path: "/mine"
                    }
                  ];
                }
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
      }
    }
  }
};
</script>
<style scoped>
img {
  width: 100%;
  height: 100%;
}

.taber {
  box-shadow: 0px -4px 5px 2px rgba(187, 187, 187, 0.3);
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 55px;
  background: #fff;
}

.youlegoutabiconbox {
  width: 58px;
  position: relative;
  height: 100%;
}

.youlegoutabicon {
  position: absolute;
  top: -10px;
  width: 58px;
  height: 58px;
  border-radius: 29px;
}

.taber_c {
  /*    flex: 1; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.taber_c_icon {
  width: 25px;
  height: 25px;
}

.taber_c_p {
  color: #000;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/taber/taber.vue